import {MenuItem, SelectField} from 'material-ui';
import FlatButton from 'material-ui/FlatButton';
import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import styled from 'styled-components';

import {HeadlineH1, HeadlineH2} from '../arkulpa-fec/components/Text';
import ActionButtonRow from '../arkulpa-fec/components/ActionButtonRow';
import ErrorMessage from '../arkulpa-fec/components/ErrorMessage';
import LoadingIndicator from '../arkulpa-fec/components/LoadingIndicator';
import config from '../config';
import filterOutNotDefinedValues from '../arkulpa-fec/utils/filterOutNotDefinedValues';
import {MoveBuilderItem, RemoveBuilderItem} from '../arkulpa-fec/components/Content/BuilderItem';
import FaAngleDoubleDown from 'react-icons/lib/fa/angle-double-down';
import FaAngleDoubleUp from 'react-icons/lib/fa/angle-double-up';
import FaTrash from 'react-icons/lib/fa/trash';
import FaPlus from 'react-icons/lib/fa/plus';
import moveElementInArray from '../arkulpa-fec/utils/moveElementInArray';
import _ from 'lodash';

const ColoredSection = styled.section`
  background: #efefef;
  margin: 40px -40px;
  padding: 30px 40px;
`;

const ContentSelectionSection = styled.div`
  border: 2px solid #efefef;
  position: relative;
  margin-top: 20px;
  padding: 20px;
`;

const ContentSelectionSectionInner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  > * {
    margin-right: 20px;
    flex: 1;
  }
  > :last-child {
    margin-right: 0;
  }
`;

const StyledSelectField = styled(SelectField)`
  margin-top: 0px;
`;

const StyledRemoveBuilderItem = styled(RemoveBuilderItem)`
  text-align: center;
  top: 15px;
  bottom: unset;
`;

const StyledMoveBuilderItem = styled(MoveBuilderItem)`
  text-align: center;
  top: 15px;
  bottom: unset;
`;

const StyledAddBuilderItem = styled(StyledRemoveBuilderItem)`
  right: 140px;
`;

const StyledAddBuilderItemBottom = styled(StyledRemoveBuilderItem)`
  position: inherit;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

export default class extends Component {
  constructor(props) {
    super(props);
    let {content, allContents} = props.data || {};
    this.state = {
      project: config.getProjectKey(),
      _id: '',
      title: '',
      items: [],

      ...filterOutNotDefinedValues(content),
      allContents: Object.values(filterOutNotDefinedValues(allContents) ? filterOutNotDefinedValues(allContents) : {}),
    };
  }

  componentWillReceiveProps = newProps => {
    let {error, content, allContents} = newProps.data || {};

    if (error) {
      const {graphQLErrors} = error || {};
      this.setState({errors: graphQLErrors});
    } else {
      this.setState({
        errors: [],
        ...filterOutNotDefinedValues(content),
        allContents: Object.values(
          filterOutNotDefinedValues(allContents) ? filterOutNotDefinedValues(allContents) : {}
        ),
      });
    }
  };

  _goBackToList = () => this.props.history.goBack();

  _renderHeadline = () => {
    if (this._isNew()) {
      return <HeadlineH1>Neue Navigation</HeadlineH1>;
    }
    return <HeadlineH1>Navigation bearbeiten</HeadlineH1>;
  };

  _removeItem = (key, idx) => {
    this.setState(p => {
      if (key === '') {
        _.unset(p.items, idx);
      } else {
        _.unset(p.items, `${key}[${idx}]`);
      }
      return p;
    });
  };

  _moveItem = (key, idx, diff) => {
    this.setState(p => {
      const values = key === '' ? p.items : _.get(p.items, key);
      const res = moveElementInArray(values, idx, diff);
      if (key === '') p.items = res;
      else _.set(p.items, key, res);
      return p;
    });
  };

  _renderNavigationSelectionItem = ({
    children,
    idx,
    jsonKeyBefore,
    jsonKey,
    label,
    value,
    url,
    urlText,
    items,
    onChange = () => {},
    renderChildren = () => {},
  }) => (
    <ContentSelectionSection key={idx}>
      <ContentSelectionSectionInner>
        <StyledSelectField
          floatingLabelText={label}
          value={value}
          onChange={(event, index, value) => onChange(value, false, false)}>
          {items.map(({_id, title}) => (
            <MenuItem key={_id} value={_id} primaryText={title} />
          ))}
        </StyledSelectField>
        {value === '__CUSTOM__' && (
          <TextField
            type="url"
            floatingLabelText="Url*"
            value={url}
            onChange={({target: {value}}) => onChange(false, value, false)}
          />
        )}
        {value === '__CUSTOM__' && (
          <TextField
            type="text"
            floatingLabelText="Url Text*"
            value={urlText}
            onChange={({target: {value}}) => onChange(false, false, value)}
          />
        )}
      </ContentSelectionSectionInner>
      <StyledRemoveBuilderItem onClick={() => this._removeItem(jsonKeyBefore, idx)}>
        <FaTrash />
      </StyledRemoveBuilderItem>
      <StyledMoveBuilderItem onClick={() => this._moveItem(jsonKeyBefore, idx, -1)} up>
        <FaAngleDoubleUp />
      </StyledMoveBuilderItem>
      <StyledMoveBuilderItem onClick={() => this._moveItem(jsonKeyBefore, idx, 1)}>
        <FaAngleDoubleDown />
      </StyledMoveBuilderItem>
      <StyledAddBuilderItem onClick={() => this._handleNavigationItemsAdd(jsonKeyBefore, jsonKey, true)}>
        <FaPlus />
      </StyledAddBuilderItem>

      {renderChildren(children)}
    </ContentSelectionSection>
  );

  _renderTemp = (allContents, items, valKey = '') =>
    items.map((item, idx) => {
      let jsonKey = `${valKey}[${idx}]`;
      const temp = {
        children: item.sub,
        idx: idx,
        jsonKeyBefore: valKey,
        jsonKey: jsonKey,
        label: 'Content',
        value: item.content,
        url: item.url,
        urlText: item.urlText,
        items: allContents,
        onChange: (value, url, urlText) =>
          this._handleNavigationChange(jsonKey, {content: value, url: url, urlText: urlText}),
        renderChildren: child => {
          if (child && child.length > 0) {
            let jsonSKey = `${jsonKey}.sub`;
            return this._renderTemp(allContents, child, jsonSKey);
          }
        },
      };
      return this._renderNavigationSelectionItem(temp);
    });

  _renderNavigationSelection = () => {
    const {allContents, items} = this.state;
    if (!allContents.length) return <div>!!allContents not defined!!</div>;
    else if (!items) return <div>!!navigation is not defined!!</div>;
    else return this._renderTemp([{_id: '__CUSTOM__', title: 'insert your own Link'}, ...allContents], items);
  };

  _isNew = () => !this.props.match.params.id;

  _handleNavigationChange = (key, {content = undefined, url = undefined, urlText = undefined}) => {
    this.setState(p => {
      content && _.set(p.items, `${key}.content`, content);
      typeof url === 'string' && _.set(p.items, `${key}.url`, url);
      typeof urlText === 'string' && _.set(p.items, `${key}.urlText`, urlText);
      return p;
    });
  };

  _handleNavigationItemsAdd = (keyBefore = undefined, key = undefined, children = undefined) => {
    const base = {content: undefined, url: '', urlText: ''};
    if (children) {
      if (key !== '') {
        this.setState(p => {
          let keyVal = _.get(p.items, key);
          let tempVal = keyVal && keyVal.sub && keyVal.sub.length ? keyVal.sub.push(base) : [base];
          let tempKey = keyVal && keyVal.sub && keyVal.sub.length ? `${keyBefore}.sub` : `${key}.sub`;
          _.set(p.items, tempKey, tempVal);
          return p;
        });
      } else {
        this.setState(p => {
          Array.isArray(p.items) ? p.items.push(base) : (p.items = [base]);
          return p;
        });
      }
    } else {
      if (key !== '') {
        this.setState(p => {
          Array.isArray(p.items) ? p.items.push(base) : (p.items = [base]);
          return p;
        });
      }
    }
  };

  _save = () => {
    const {project, items, title, _id} = filterOutNotDefinedValues(this.state);
    console.log({
      items: items && items.length ? items : [],
      project: project,
      title: title,
      _id: _id,
    });
    /*
    this.props
      .save({
        navigation: navigation && navigation.length ? navigation : [],
        project: project,
        title: title,
        _id: _id
      })
      .then(() => this._goBackToList())
      .catch(rawErrors => {
        let errors = convertErrors(rawErrors);
        this.setState({errors});
        console.log('there was an error sending the query', errors);
      });
    */
  };

  render() {
    let {title} = this.state;
    if (this.props.data && this.props.data.loading) {
      return <LoadingIndicator />;
    }
    return (
      <div>
        <ErrorMessage errors={this.state.errors} clearErrors={() => this.setState({errors: []})} />
        {this._renderHeadline()}
        <ColoredSection>
          <TextField
            type="text"
            fullWidth={true}
            floatingLabelText="Title*"
            value={title}
            onChange={({target: {value}}) => this.setState({title: value})}
          />
        </ColoredSection>
        <HeadlineH2 margin="0 0 1em">Navigation Content</HeadlineH2>
        {this._renderNavigationSelection()}
        <StyledAddBuilderItemBottom onClick={() => this._handleNavigationItemsAdd()}>
          <FaPlus />
        </StyledAddBuilderItemBottom>
        <ActionButtonRow>
          <FlatButton onClick={this._goBackToList} label="Zurück zur Übersicht" />
          <div>
            {/*!this._isNew() && <FlatButton onClick={() => this.setState({deleteModalOpen: true})} label="löschen" />*/}
            <FlatButton primary onClick={this._save} label="speichern" />
          </div>
        </ActionButtonRow>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavigationForm.js